import { Injectable } from '@angular/core';
import moment from 'moment-timezone';

import { WindowRef } from 'src/shared/utility/window-ref';

export const NEW_RELIC_KNOWN_ERRORS = {
  genericError: 'Report caught error to New Relic',
  tradeError: 'Caught trade error',
  progressEvent: 'Caught ProgressEvent error',
};

@Injectable()
export class NewRelicLogger {
  private APP_ID = 16;

  constructor(private winRef: WindowRef) {
    this.setIgnoreErrorHandler();
  }

  setEvent(eventName: string, requestObject: any, customAttributes?: any) {
    const fixedRequestObject: any = {
      ...requestObject,
    };

    if (requestObject instanceof ProgressEvent) {
      const xhrURL = this.getMessageFromProgressEvent(requestObject);
      fixedRequestObject.xhrURL = xhrURL;
    }

    this._doSetEvent(eventName, { ...fixedRequestObject, ...customAttributes });
  }

  buildHash(
    timestamp: any,
    contrato: any,
    issue: any,
    titles: any,
    orden: any,
  ) {
    return `${this.APP_ID}${timestamp}${contrato}${issue.replace(
      ' ',
      '',
    )}${titles}${orden}`;
  }

  setError(error: Error, customAttributes: any = {}) {
    this.winRef.nativeWindow.newrelic &&
      this.winRef.nativeWindow.newrelic.noticeError(error, customAttributes);
  }

  private _doSetEvent(eventName: string, requestObject: any) {
    const startedTime = moment(requestObject.startedTime || new Date());
    const currentTime = moment(new Date());

    requestObject.startedTime = startedTime.format('YYYY-MM-DD hh:mm:ss.SSS');
    requestObject.finishedTime = currentTime.format('YYYY-MM-DD hh:mm:ss.SSS');

    const newrelic = this.winRef.nativeWindow.newrelic;
    newrelic &&
      newrelic.addPageAction &&
      newrelic.addPageAction(eventName, requestObject);
  }

  private setIgnoreErrorHandler() {
    const newrelic = this.winRef.nativeWindow.newrelic;
    newrelic &&
      newrelic.setErrorHandler &&
      newrelic.setErrorHandler((error: any) => {
        if (error instanceof ProgressEvent) {
          try {
            const xhrURL = this.getMessageFromProgressEvent(error);
            this.setError(new Error(NEW_RELIC_KNOWN_ERRORS.progressEvent), {
              ...error,
              xhrURL,
            });
          } catch (error) {}
          return true;
        }
        return false;
      });
  }

  private getMessageFromProgressEvent(value: ProgressEvent) {
    const xhrURL =
      (value.target && (value as any).target.__zone_symbol__xhrURL) ||
      'Unknown xhrURL';
    const errorMessage = `ProgressEvent at ${xhrURL.replace(/\//g, '|')}`;
    return errorMessage;
  }
}
